/* N1 · Clic en los cards de los carruseles.
   - Toque limpio: navegamos nosotros (el carrusel cancelaba el clic).
   - Arrastre: bloqueamos el clic para que el navegador tampoco abra el enlace.
   ?n1debug=1 en la URL muestra un panel con lo que ocurre en cada gesto (el panel se crea cuando el cuerpo de la página existe). */
(function(){
if(window.N1CardFix)return;window.N1CardFix=1;
var DBG=/[?&]n1debug=1/.test(location.search),box=null,pend=[];
function paint(m){if(!box){var host=document.body;if(!host){pend.push(m);return}box=document.createElement('div');box.style.cssText='position:fixed;left:8px;right:8px;bottom:8px;z-index:2147483646;max-height:30vh;overflow:auto;background:rgba(0,0,0,.88);color:#e4ee05;font:12px/1.35 monospace;padding:10px;border:1px solid #e4ee05;border-radius:8px;white-space:pre-wrap';host.appendChild(box)}box.textContent=(new Date().toISOString().substr(14,9))+'  '+m+'\n'+box.textContent}
function log(m){if(DBG)paint(m)}
if(DBG)document.addEventListener('DOMContentLoaded',function(){var p=pend;pend=[];p.forEach(paint)});
var x0=null,y0=null,t0=0,maxd=0,lastEnd=0;
function start(x,y){x0=x;y0=y;t0=Date.now();maxd=0}
function move(x,y){if(x0===null)return;var d=Math.max(Math.abs(x-x0),Math.abs(y-y0));if(d>maxd)maxd=d}
function endGesture(){if(maxd>12)lastEnd=Date.now()}
document.addEventListener('pointerdown',function(e){start(e.clientX,e.clientY)},true);
document.addEventListener('pointermove',function(e){move(e.clientX,e.clientY)},true);
document.addEventListener('pointerup',endGesture,true);
document.addEventListener('pointercancel',endGesture,true);
document.addEventListener('mousedown',function(e){start(e.clientX,e.clientY)},true);
document.addEventListener('mousemove',function(e){if(e.buttons)move(e.clientX,e.clientY)},true);
document.addEventListener('mouseup',endGesture,true);
document.addEventListener('touchstart',function(e){if(e.touches&&e.touches[0])start(e.touches[0].clientX,e.touches[0].clientY)},true);
document.addEventListener('touchmove',function(e){if(e.touches&&e.touches[0])move(e.touches[0].clientX,e.touches[0].clientY)},{capture:true,passive:true});
document.addEventListener('touchend',endGesture,true);
function card(t){return t&&t.closest?t.closest('a.n1-pc, a.n1-card'):null}
function dragged(e){
  if(maxd>12)return true;
  if(lastEnd&&Date.now()-lastEnd<400)return true;
  if(x0!==null&&Date.now()-t0<=1500){
    var dx=Math.abs((e.clientX||0)-x0),dy=Math.abs((e.clientY||0)-y0);
    if(dx>12||dy>12)return true;
  }
  return false;
}
document.addEventListener('click',function(e){
  var a=card(e.target);if(!a)return;
  if(e.metaKey||e.ctrlKey||e.shiftKey||e.button)return;
  var href=a.getAttribute('href');
  if(!href||href.charAt(0)==='#')return;
  if(dragged(e)){
    log('arrastre ('+Math.round(maxd)+'px): bloqueo la apertura');
    e.preventDefault();e.stopPropagation();
    if(e.stopImmediatePropagation)e.stopImmediatePropagation();
    return;
  }
  log('toque: navegando -> '+href);
  e.preventDefault();e.stopPropagation();
  if(e.stopImmediatePropagation)e.stopImmediatePropagation();
  window.location.assign(href);
},true);
log('n1-cardfix activo');
})();
